var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "function-card" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          staticStyle: { "margin-right": "5px" },
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.createMenuModal({ type: "parent" })
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Add")) + " ")]
      ),
      _c(
        "button",
        {
          staticClass: "btn btn-info",
          attrs: {
            type: "button",
            "data-toggle": "modal",
            "data-target": "#localizationModal",
          },
          on: {
            click: function ($event) {
              _vm.tableData = JSON.parse(JSON.stringify(_vm.originalData))
            },
          },
        },
        [_vm._v(" 多國語系 ")]
      ),
    ]),
    _c(
      "div",
      { staticClass: "yahome-table-wrap" },
      [
        _c("VueTreeGrid", {
          key: _vm.treeKey,
          attrs: {
            columns: _vm.columns,
            tree: _vm.tree,
            emptyText: "暫無資料",
          },
          on: { expand: _vm.expandMenu },
          scopedSlots: _vm._u([
            {
              key: "sort--row-cell",
              fn: function (scope) {
                return [
                  _c("div", { staticClass: "text-center" }, [
                    scope.row._index !== 0
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn btn-outline-secondary btn-sm",
                            on: {
                              click: function ($event) {
                                return _vm.changeSort({
                                  item: scope.row,
                                  action: "up",
                                })
                              },
                            },
                          },
                          [_c("i", { staticClass: "fas fa-long-arrow-alt-up" })]
                        )
                      : _vm._e(),
                    scope.row._level === 1
                      ? _c("span", [
                          scope.row._index !== _vm.tree.length - 1
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn btn-outline-secondary btn-sm",
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeSort({
                                        item: scope.row,
                                        action: "down",
                                      })
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-long-arrow-alt-down",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    scope.row._level === 2
                      ? _c("span", [
                          scope.row._index !== scope.row.childrenLength - 1
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn btn-outline-secondary btn-sm",
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeSort({
                                        item: scope.row,
                                        action: "down",
                                      })
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-long-arrow-alt-down",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]),
                ]
              },
            },
            {
              key: "menuName--row-cell",
              fn: function (scope) {
                return [
                  scope.row.LocalizationalMenus.length > 0
                    ? _vm._l(scope.row.LocalizationalMenus, function (item) {
                        return _c("span", { key: item.LocalizationTypeGuid }, [
                          item.LocalizationTypeCode === _vm.currentLanguage
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.MenuName
                                        ? item.MenuName
                                        : scope.row.MenuName
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ])
                      })
                    : _c("span", [
                        _vm._v(" " + _vm._s(scope.row.MenuName) + " "),
                      ]),
                ]
              },
            },
            {
              key: "action--row-cell",
              fn: function (scope) {
                return [
                  scope.row._level === 1
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.createMenuModal({
                                type: "child",
                                data: scope.row,
                              })
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Add")) + " ")]
                      )
                    : _vm._e(),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-info btn-sm",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.editMenuModal(scope.row)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Edit")) + " ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger btn-sm",
                      attrs: {
                        type: "button",
                        "data-toggle": "modal",
                        "data-target": "#delMenu",
                      },
                      on: {
                        click: function ($event) {
                          _vm.deleteTemp = scope.row
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Delete")) + " ")]
                  ),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "modal",
        attrs: {
          id: "localizationModal",
          tabindex: "-1",
          "data-focus": "false",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-centered modal-xl" },
          [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(0),
              _c("div", { staticClass: "modal-body" }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.tableData,
                          "row-key": "MenuGuid",
                          border: "",
                          height: "800",
                          "default-expand-all": "",
                          "tree-props": {
                            children: "Children",
                          },
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            fixed: "",
                            prop: "MenuName",
                            label: "選單名稱",
                            width: "180",
                          },
                        }),
                        _vm._l(_vm.localizationList, function (language) {
                          return _c("el-table-column", {
                            key: language.LocalizationTypeGuid,
                            attrs: {
                              label:
                                language.LocalizationTypeCode +
                                " (" +
                                language.LocalizationTypeName +
                                ")",
                              width: "250",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return _vm._l(
                                      scope.row.LocalizationalMenus,
                                      function (content) {
                                        return _c(
                                          "span",
                                          { key: content.LocalizationTypeGuid },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    content.LocalizationTypeGuid ===
                                                    language.LocalizationTypeGuid,
                                                  expression:
                                                    "\n                        content.LocalizationTypeGuid ===\n                        language.LocalizationTypeGuid\n                      ",
                                                },
                                                {
                                                  name: "model",
                                                  rawName: "v-model.trim",
                                                  value: content.MenuName,
                                                  expression:
                                                    "content.MenuName",
                                                  modifiers: { trim: true },
                                                },
                                              ],
                                              staticClass: "form-control",
                                              domProps: {
                                                value: content.MenuName,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    content,
                                                    "MenuName",
                                                    $event.target.value.trim()
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            }),
                                          ]
                                        )
                                      }
                                    )
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button", "data-dismiss": "modal" },
                  },
                  [_vm._v(" 取消 ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    attrs: { type: "button" },
                    on: { click: _vm.saveLocalization },
                  },
                  [_vm._v(" 儲存 ")]
                ),
              ]),
            ]),
          ]
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "createModal",
          tabindex: "-1",
          "data-backdrop": "static",
          "data-focus": "false",
        },
      },
      [
        _c(
          "div",
          {
            staticClass:
              "modal-dialog modal-dialog-scrollable modal-dialog-centered",
          },
          [
            _c("ValidationObserver", {
              ref: "createMenu",
              staticClass: "modal-content",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit, reset }) {
                    return [
                      _c(
                        "form",
                        {
                          on: {
                            reset: function ($event) {
                              $event.preventDefault()
                              return reset.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "modal-header" }, [
                            !_vm.ParentName
                              ? _c("span", [
                                  _vm._v(
                                    " " + _vm._s(_vm.i18n("Menu.AddMain")) + " "
                                  ),
                                ])
                              : _c("span", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "badge badge-primary",
                                      staticStyle: { "font-size": "15px" },
                                    },
                                    [_vm._v(" " + _vm._s(_vm.ParentName) + " ")]
                                  ),
                                  _vm._v(
                                    " " + _vm._s(_vm.i18n("Menu.AddSub")) + " "
                                  ),
                                ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "modal-body",
                              staticStyle: { height: "400px" },
                            },
                            [
                              !_vm.ParentName
                                ? _c(
                                    "div",
                                    { staticClass: "form-group" },
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          name: "icon",
                                          rules: "required",
                                          tag: "div",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c(
                                                    "label",
                                                    { attrs: { for: "" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "mark" },
                                                        [_vm._v("*")]
                                                      ),
                                                      _vm._v("icon"),
                                                    ]
                                                  ),
                                                  _c("multiselect", {
                                                    attrs: {
                                                      placeholder: "請選擇",
                                                      label: "title",
                                                      "track-by": "title",
                                                      options: _vm.iconList,
                                                      "show-labels": false,
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "singleLabel",
                                                          fn: function (props) {
                                                            return [
                                                              _c("img", {
                                                                staticStyle: {
                                                                  height:
                                                                    "25px",
                                                                },
                                                                attrs: {
                                                                  src: props
                                                                    .option.img,
                                                                  alt: "icon",
                                                                },
                                                              }),
                                                            ]
                                                          },
                                                        },
                                                        {
                                                          key: "option",
                                                          fn: function (props) {
                                                            return [
                                                              _c("img", {
                                                                staticStyle: {
                                                                  height:
                                                                    "30px",
                                                                },
                                                                attrs: {
                                                                  src: props
                                                                    .option.img,
                                                                  alt: "icon",
                                                                },
                                                              }),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                    model: {
                                                      value: _vm.icon,
                                                      callback: function ($$v) {
                                                        _vm.icon = $$v
                                                      },
                                                      expression: "icon",
                                                    },
                                                  }),
                                                  errors[0]
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("ValidationProvider", {
                                    attrs: {
                                      name: _vm.i18n("Menu.MenuName"),
                                      rules: "required",
                                      tag: "div",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "label",
                                                {
                                                  attrs: { for: "create-name" },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "mark" },
                                                    [_vm._v("*")]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n(
                                                          "Menu.MenuName"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "mark" },
                                                    [_vm._v("(不可重複)")]
                                                  ),
                                                ]
                                              ),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.createTemp.MenuName,
                                                    expression:
                                                      "createTemp.MenuName",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  type: "text",
                                                  id: "create-name",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.createTemp.MenuName,
                                                },
                                                on: {
                                                  compositionstart: function (
                                                    $event
                                                  ) {
                                                    _vm.is_composing = true
                                                  },
                                                  compositionend: function (
                                                    $event
                                                  ) {
                                                    _vm.is_composing = false
                                                  },
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.createTemp,
                                                      "MenuName",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              errors[0] && !_vm.is_composing
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm.ParentName
                                ? _c(
                                    "div",
                                    { staticClass: "form-group" },
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          name: _vm.i18n("Menu.MenuLink"),
                                          rules: "required",
                                          tag: "div",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: "create-link",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "mark" },
                                                        [_vm._v("*")]
                                                      ),
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.i18n(
                                                            "Menu.MenuLink"
                                                          )
                                                        ) + " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.createTemp.Link,
                                                        expression:
                                                          "createTemp.Link",
                                                      },
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      id: "create-link",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.createTemp.Link,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.createTemp,
                                                          "Link",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(errors[0]) + " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.ParentName
                                ? _c("div", { staticClass: "form-group" }, [
                                    _c("label", { attrs: { for: "" } }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v(
                                        _vm._s(_vm.i18n("Menu.ExternalLink")) +
                                          " "
                                      ),
                                    ]),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.createTemp.ExternalLink,
                                            expression:
                                              "createTemp.ExternalLink",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.createTemp,
                                              "ExternalLink",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          { domProps: { value: true } },
                                          [_vm._v("是")]
                                        ),
                                        _c(
                                          "option",
                                          { domProps: { value: false } },
                                          [_vm._v("否")]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.ParentName
                                ? [
                                    !_vm.createTemp.ExternalLink
                                      ? _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.i18n(
                                                        "Menu.OpenAnotherWindow"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.createTemp.NewWindow,
                                                    expression:
                                                      "createTemp.NewWindow",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                on: {
                                                  change: function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.$set(
                                                      _vm.createTemp,
                                                      "NewWindow",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  { domProps: { value: true } },
                                                  [_vm._v("是")]
                                                ),
                                                _c(
                                                  "option",
                                                  {
                                                    domProps: { value: false },
                                                  },
                                                  [_vm._v("否")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                              _c(
                                "el-collapse",
                                {
                                  attrs: { accordion: "" },
                                  model: {
                                    value: _vm.collapseOpen,
                                    callback: function ($$v) {
                                      _vm.collapseOpen = $$v
                                    },
                                    expression: "collapseOpen",
                                  },
                                },
                                [
                                  _c(
                                    "el-collapse-item",
                                    {
                                      staticClass: "el-collapse-header",
                                      attrs: { title: "多國語系", name: "1" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "w-100" },
                                        [
                                          _vm._l(
                                            _vm.localizationList,
                                            function (language, index) {
                                              return [
                                                _c(
                                                  "label",
                                                  {
                                                    key: language.LocalizationTypeGuid,
                                                    attrs: {
                                                      for: `createLanguage${index}`,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          language.LocalizationTypeName
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value: language.MenuName,
                                                      expression:
                                                        "language.MenuName",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  key: language.LocalizationTypeCode,
                                                  staticClass:
                                                    "form-control w-100 mb-2",
                                                  attrs: {
                                                    id: `createLanguage${index}`,
                                                  },
                                                  domProps: {
                                                    value: language.MenuName,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        language,
                                                        "MenuName",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                              ]
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                          _c("div", { staticClass: "modal-footer" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: {
                                  type: "reset",
                                  "data-dismiss": "modal",
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.i18n("Buttons.Cancel")) + " "
                                ),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return handleSubmit(_vm.createMenu)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.i18n("Buttons.Save")) + " "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "editModal",
          tabindex: "-1",
          "data-backdrop": "static",
          "data-focus": "false",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-centered" },
          [
            _c("ValidationObserver", {
              ref: "editMenu",
              staticClass: "modal-content",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit, reset }) {
                    return [
                      _c(
                        "form",
                        {
                          on: {
                            reset: function ($event) {
                              $event.preventDefault()
                              return reset.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "modal-header" }, [
                            !_vm.ParentName
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.i18n("Menu.EditMain"))),
                                ])
                              : _c("span", [
                                  _vm._v(_vm._s(_vm.i18n("Menu.EditSub"))),
                                ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "modal-body",
                              staticStyle: { height: "400px" },
                            },
                            [
                              !_vm.ParentName
                                ? _c(
                                    "div",
                                    { staticClass: "form-group" },
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          name: "icon",
                                          rules: "required",
                                          tag: "div",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c(
                                                    "label",
                                                    { attrs: { for: "" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "mark" },
                                                        [_vm._v("*")]
                                                      ),
                                                      _vm._v("icon"),
                                                    ]
                                                  ),
                                                  _c("multiselect", {
                                                    attrs: {
                                                      placeholder: "請選擇",
                                                      label: "title",
                                                      "track-by": "title",
                                                      options: _vm.iconList,
                                                      "show-labels": false,
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "singleLabel",
                                                          fn: function (props) {
                                                            return [
                                                              _c("img", {
                                                                staticStyle: {
                                                                  height:
                                                                    "25px",
                                                                },
                                                                attrs: {
                                                                  src: props
                                                                    .option.img,
                                                                  alt: "icon",
                                                                },
                                                              }),
                                                            ]
                                                          },
                                                        },
                                                        {
                                                          key: "option",
                                                          fn: function (props) {
                                                            return [
                                                              _c("img", {
                                                                staticStyle: {
                                                                  height:
                                                                    "30px",
                                                                },
                                                                attrs: {
                                                                  src: props
                                                                    .option.img,
                                                                  alt: "icon",
                                                                },
                                                              }),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                    model: {
                                                      value: _vm.icon,
                                                      callback: function ($$v) {
                                                        _vm.icon = $$v
                                                      },
                                                      expression: "icon",
                                                    },
                                                  }),
                                                  errors[0]
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("ValidationProvider", {
                                    attrs: {
                                      name: _vm.i18n("Menu.MenuName"),
                                      rules: "required",
                                      tag: "div",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "label",
                                                { attrs: { for: "edit-name" } },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "mark" },
                                                    [_vm._v("*")]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n(
                                                          "Menu.MenuName"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.editTemp.MenuName,
                                                    expression:
                                                      "editTemp.MenuName",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  type: "text",
                                                  id: "edit-name",
                                                },
                                                domProps: {
                                                  value: _vm.editTemp.MenuName,
                                                },
                                                on: {
                                                  compositionstart: function (
                                                    $event
                                                  ) {
                                                    _vm.is_composing = true
                                                  },
                                                  compositionend: function (
                                                    $event
                                                  ) {
                                                    _vm.is_composing = false
                                                  },
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.editTemp,
                                                      "MenuName",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              errors[0] && !_vm.is_composing
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm.canEdit
                                ? _c(
                                    "div",
                                    { staticClass: "form-group" },
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          name: _vm.i18n("Menu.MenuLink"),
                                          rules: "required",
                                          tag: "div",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: "edit-link",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "mark" },
                                                        [_vm._v("*")]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.i18n(
                                                              "Menu.MenuLink"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.editTemp.Link,
                                                        expression:
                                                          "editTemp.Link",
                                                      },
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      id: "edit-link",
                                                    },
                                                    domProps: {
                                                      value: _vm.editTemp.Link,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.editTemp,
                                                          "Link",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(errors[0]) + " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.ParentName
                                ? _c("div", { staticClass: "form-group" }, [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.i18n("Menu.OpenAnotherWindow")
                                        )
                                      ),
                                    ]),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.editTemp.NewWindow,
                                            expression: "editTemp.NewWindow",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.editTemp,
                                              "NewWindow",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          { domProps: { value: true } },
                                          [_vm._v("是")]
                                        ),
                                        _c(
                                          "option",
                                          { domProps: { value: false } },
                                          [_vm._v("否")]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.canEdit
                                ? _c("div", { staticClass: "form-group" }, [
                                    _c("label", { attrs: { for: "" } }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.i18n("Menu.ExternalLink")
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.editTemp.ExternalLink,
                                            expression: "editTemp.ExternalLink",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.editTemp,
                                              "ExternalLink",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          { domProps: { value: true } },
                                          [_vm._v("是")]
                                        ),
                                        _c(
                                          "option",
                                          { domProps: { value: false } },
                                          [_vm._v("否")]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _c(
                                "el-collapse",
                                {
                                  attrs: { accordion: "" },
                                  model: {
                                    value: _vm.collapseOpen,
                                    callback: function ($$v) {
                                      _vm.collapseOpen = $$v
                                    },
                                    expression: "collapseOpen",
                                  },
                                },
                                [
                                  _c(
                                    "el-collapse-item",
                                    {
                                      staticClass: "el-collapse-header",
                                      attrs: { title: "多國語系", name: "1" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "w-100" },
                                        [
                                          _vm._l(
                                            _vm.editTemp.LocalizationalMenus,
                                            function (language, index) {
                                              return [
                                                _c(
                                                  "label",
                                                  {
                                                    key: language.LocalizationTypeGuid,
                                                    attrs: {
                                                      for: `editLanguage${index}`,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          language.LocalizationTypeName
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value: language.MenuName,
                                                      expression:
                                                        "language.MenuName",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  key: language.LocalizationTypeCode,
                                                  staticClass:
                                                    "form-control w-100 mb-2",
                                                  attrs: {
                                                    id: `editLanguage${index}`,
                                                  },
                                                  domProps: {
                                                    value: language.MenuName,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        language,
                                                        "MenuName",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                              ]
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "modal-footer" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: {
                                  type: "reset",
                                  "data-dismiss": "modal",
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.i18n("Buttons.Cancel")) + " "
                                ),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return handleSubmit(_vm.editMenu)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.i18n("Buttons.Save")) + " "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "delMenu", tabindex: "-1", "data-backdrop": "static" },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _vm._v(_vm._s(_vm.i18n("Menu.DeleteMenu"))),
            ]),
            _c("div", { staticClass: "modal-body" }, [
              _vm._v(" 確認刪除 "),
              _c(
                "span",
                { staticStyle: { "font-weight": "bolder", color: "red" } },
                [_vm._v(" " + _vm._s(_vm.deleteTemp.MenuName))]
              ),
              _vm._v(" ? "),
            ]),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "reset", "data-dismiss": "modal" },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Cancel")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: { click: _vm.delMenu },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Delete")) + " ")]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("多國語系")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }